<span
    #textElement
    class="truncate-text"
    [ngbTooltip]="isTruncated() ? text() : null"
>
    {{ text() }}
</span>
